import apiClient from "./apiClient";
import {ResponseDto} from "./ResponseDto";
import {TermsTypes} from "../types/terms.types";
import {SearchTypes} from "../types/common/search.types";
import {PageTypes} from "../types/page.types";
import {MemberAlarmSettingType} from "../types/alarm.types";

export const getNotReadPushAlarmCount = () =>
    apiClient.get<ResponseDto<number>>("/api/front/alarm/getNotReadPushAlarmCount");


export const getMemberPushAlarmHistories = (searchData : SearchTypes) =>
    apiClient.get<ResponseDto<PageTypes>>("/api/front/alarm/getMemberPushAlarmHistories",
        {
            params: searchData,
            headers: {'Content-Type': 'application/json'}
        }
    );


export const getMemberPushAlarmSetting = () =>
    apiClient.get<ResponseDto<MemberAlarmSettingType>>("/api/front/alarm/getMemberPushAlarmSetting");

export const updateNightSendAllowed = (nightSendAllowed: boolean) =>
    apiClient.patch<ResponseDto<any>>("/api/front/alarm/updateNightSendAllowed",
        {nightSendAllowed: nightSendAllowed}
    );